























































import { Component, Vue } from 'vue-property-decorator';
import Message from '@/common/components/Message.vue';
import Loader from '@/common/components/Loader.vue';
import { UserService, ResetPasswordParamsInterface, SuccessResponseBodyInterface } from '@/common/services/user.service';
import { ErrorInterface } from '@/common/helpers/error.helper';
import { prepareRequestParams } from '@/common/helpers/prepare-request-data.helper';
import APP_CONFIG from '../config';
import { getText } from '@/common/locales';

// Minimalna długość hasła
const MIN_PASSWORD_LENGTH = 6;

@Component({
    components: {
        Message,
        Loader,
    },
})
export default class ResetPassword extends Vue {
    public messageTitle = '';
    public messageDescription = '';
    public isLoading = false;
    public isFormVisible = true;
    public password = '';
    public repeatPassword = '';

    private isFormSubmitted = false;

    public getText(phrase: string): string {
        return getText(phrase);
    }

    public get errorMessage(): string {
        if (!this.isFormSubmitted) {
            return '';
        }

        if (this.isPasswordLengthInvalid) {
            return getText('components.reset_password.password_is_too_short');
        }

        if (this.isPasswordMatchInvalid) {
            return getText('components.reset_password.incorrect_data_enter_password_again');
        }

        return '';
    }

    public onSubmit(e: Event): void {
        e.preventDefault();
        this.isFormSubmitted = true;

        if (this.isFormInvalid) {
            return;
        }

        this.isFormVisible = false;
        this.resetPassword();
    }

    private resetPassword(): void {
        this.isLoading = true;
        UserService.resetPassword(this.resetPasswordParams)
            .then(this.resetPasswordSuccess)
            .catch(this.resetPasswordError);
    }

    private resetPasswordSuccess(response: SuccessResponseBodyInterface): void {
        this.isLoading = false;
        this.messageTitle = getText('components.reset_password.password_changed');
    }

    private resetPasswordError(error: ErrorInterface): void {
        this.isLoading = false;
        this.messageTitle = getText('components.reset_password.password_change_error');
        this.messageDescription = getText('components.reset_password.try_again');
    }

    private get resetPasswordParams(): ResetPasswordParamsInterface {
        const { UAD_PORTAL, BASE_USER_AGENT } = APP_CONFIG;
        const params = {
            password: this.password,
            verificationCode: this.$route.params.token,
        };

        return prepareRequestParams(params, UAD_PORTAL, BASE_USER_AGENT) as ResetPasswordParamsInterface;
    }

    private get isFormInvalid(): boolean {
        if (this.isPasswordLengthInvalid || this.isPasswordMatchInvalid) {
            return true;
        }

        return false;
    }

    private get isPasswordLengthInvalid(): boolean {
        return this.password.length < MIN_PASSWORD_LENGTH;
    }

    private get isPasswordMatchInvalid(): boolean {
        return this.password !== this.repeatPassword;
    }
}
